import React from "react";
import CompaniesList from "./CompaniesList";

export default function index() {
  return (
    <>
      <CompaniesList />
    </>
  );
}
